import React from "react"

import SEO from "@components/seo"
import Container from "@components/container"
import EventTime from "@components/eventTime"
import GameTabs from "@components/gameTabs"
import Splatoon from "@components/pages/season1/splatoon"
import MonsterHunter from "@components/pages/season1/monsterHunter"
import SuperSmashBros from "@components/pages/season1/superSmashBros"

import splatoonLogo from "@images/splatoon.png"
import monsterHunterLogo from "@images/mh.png"
import superSmashBrosLogo from "@images/ssb.png"

const Season1 = () => {
  return (
    <>
      <SEO title="SEASON 1" />
      <EventTime enroll="4.06 ~ 4.17" start="4.23 ~ 5.10" />
      <Container>
        <GameTabs
          games={[
            { key: "splatoon", title: "Splatoon 2", logo: splatoonLogo },
            {
              key: "monsterHunter",
              title: "怪物猎人世界：冰原",
              logo: monsterHunterLogo,
            },
            {
              key: "superSmashBros",
              title: "任天堂明星大乱斗 特别版",
              logo: superSmashBrosLogo,
            },
          ]}
        >
          {key => {
            if (key === "splatoon") {
              return <Splatoon />
            } else if (key === "monsterHunter") {
              return <MonsterHunter />
            } else if (key === "superSmashBros") {
              return <SuperSmashBros />
            }
          }}
        </GameTabs>
      </Container>
    </>
  )
}

export default Season1
